import DashboardLoader from "./components/DashboardLoader";
export default function App() {
  return <DashboardLoader />;
}
